import { startOfWeek, add, format, compareAsc } from "date-fns";

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return format(date, "yyyy-MM-dd");
};

export const parseISODate = (dateStr) => {
  const [year, month, day] = dateStr.split("-").map(Number);
  return new Date(year, month - 1, day);
};

export const groupByWeek = (agendas) => {
  const sortedAgendas = agendas.sort((a, b) =>
    compareAsc(
      parseISODate(a.closeDate.split("T")[0]),
      parseISODate(b.closeDate.split("T")[0])
    )
  );

  const weeks = {};
  agendas.forEach((agenda) => {
    const date = parseISODate(agenda.closeDate.split("T")[0]);
    const weekStart = startOfWeek(date, { weekStartsOn: 1 }); // 주 시작은 월요일로 설정
    const weekKey = format(weekStart, "yyyy-MM-dd");

    if (!weeks[weekKey]) {
      weeks[weekKey] = [];
    }

    weeks[weekKey].push(agenda);
  });
  return weeks;
};
